import React, { useEffect, useState } from "react";
import { Router, Switch, Route, Redirect } from "react-router-dom";
import { createBrowserHistory } from "history";
import DetailScreen from "./screens/DetailScreen/DetailScreen";
import MainScreen from "./screens";
import CustomerInfoScreen from "./screens/CustomerInfoScreen/CustomerInfoScreen";
import ContractDetailScreen from "./screens/ContractDetailScreen/ContractDetailScreen";
import ContractReviewScreen from "./screens/ContractReviewScreen/ContractReviewScreen";
import QAScreen from "./screens/QAScreen/QAScreen";
import QADetailScreen from "./screens/QADetailScreen/QADetailScreen";
import { useDispatch } from "react-redux";
import { getOauthV1Code, getTokenUser } from "./stores/appparams/appparams.action";
import { PATH } from "./utils/const";
import RenewalInsuranceDetailsScreen from "screens/RenewalInsuranceDetailsScreen/RenewalInsuranceDetailsScreen";
import FireExplosionInsuranceScreen from "screens/FireExplosionInsuranceScreen/FireExplosionInsuranceScreen";

import "./index.scss";
import Contact from "components/Contact/Contact";
import RenewalScreen from "screens/RenewalScreen/RenewalScreen";
import CarInsuranceScreen from "screens/CarInsuranceScreen/CarInsuranceScreen";

const history = createBrowserHistory();

function App() {
  const dispatch = useDispatch();
  const [isLogin, setIsLogin] = useState(false);
  const {search} = window.location;

  // useEffect(() => {
  //   dispatch(getTokenUser((isSuccess) => setIsLogin(isSuccess)));
  // }, [dispatch]);

  useEffect(() => {
    dispatch(getOauthV1Code((isSuccess) => setIsLogin(isSuccess)))
  }, [dispatch])

  const routes = [
    {
      path: `${PATH}/detail/:code`,
      component: () => <DetailScreen />,
    },
    {
      path: `${PATH}/customer-info`,
      component: () => <CustomerInfoScreen />,
    },
    {
      path: `${PATH}/contract-detail/:quotationCode`,
      component: () => <ContractDetailScreen type="contract-detail" />,
    },
    {
      path: `${PATH}/external-contract-detail/:quotationCode`,
      component: () => <ContractDetailScreen type="external-contract-detail" />,
    },
    {
      path: `${PATH}/contract-review/:quotationCode`,
      component: () => <ContractReviewScreen />,
    },
    {
      path: `${PATH}/qa`,
      component: () => <QAScreen />,
    },
    {
      path: `${PATH}/qa-detail`,
      component: () => <QADetailScreen />,
    },
    {
      path: `${PATH}/renewal`,
      component: () => <RenewalScreen />,
    },
    {
      path: `${PATH}/renewal-insurance-details/:quotationCode`,
      component: () => <RenewalInsuranceDetailsScreen type="contract-detail" />
    },
    {
      path: `${PATH}/fire-explosion-insurance`,
      component: () => <FireExplosionInsuranceScreen />,
    },
    {
      path: `${PATH}/car-insurance`,
      component: () => <CarInsuranceScreen />,
    },
    {
      path: `${PATH}/`,
      component: () => <MainScreen />,
    },
  ];

  return (
    <div>
      {isLogin ? (
        <Router basename={process.env.PUBLIC_URL} history={history}>
          <Switch>
            <Route exact path={"/"}>
              <Redirect to={{
                pathname: `${PATH}`,
                search,
              }} />
            </Route>
            {routes.map((item) => (
              <Route
                key={item.path}
                path={item.path}
                children={item.component}
              />
            ))}
          </Switch>
          <Contact />
        </Router>
      ) : null}
    </div>
  );
}

export default App;
